//@ts-check
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import ParameterInput from "./parameter-input"
import StepHeader from "./step-header"
import StyleWrapper from "../utils/stylesWrapper"
import { Input } from "./input"
import ValueOrChoose from "./value-or-choose"
import Button from "./button"
import { CircularProgress } from "@material-ui/core"
import defaultParametersFor from "../../../shared/default-parameters-for-abi-inputs"
import store, { qs } from "../store"
import ParameterDisplay from "./parameter-display"
import web3 from "../utils/web3"
import {
  getNewContractAddress,
  getNewRandomContractAddress,
} from "./getNewContractAddress"
import CompileDialog from "./compile-dialog"
const CONSTS = require("shared/consts")
const COMPILE_SMART_CONTRACT = CONSTS.STEP_TYPES.COMPILE_SMART_CONTRACT
import FunctionChooser from "./function-chooser"
import { requestJSON } from "../utils/request-module"
import BlockEdit from "./block-edit"
import { useLocalStorage } from "../utils/use-local-storage"
import useIsLoggedIn from "src/utils/use-is-logged-in"
import Progress from "./progress"
import { useStepIndex } from "./step-index-context"
import EditIcon from "@material-ui/icons/Edit"
import CompileDialogForReview from "./compileDialogForReview"
import addSignaturesToABI from "../add-signature-to-abi"

const SHOW_CHANGE_DATA = true

export default function CompileContractStep({ skipStepNumber = false }) {
  const { isLoggedIn } = useIsLoggedIn()
  var [showDescrtionInput, setShowDescrtionInput] = useState(false)
  const [showEditReviewFileModal, setShowEditReviewFileModal] = useState(false)
  var [showDestinationAddressInput, setShowDestinationAddressInput] =
    store.simulationReviewId
      ? useLocalStorage("showDestinationAddress", false)
      : useState(false)
  showDestinationAddressInput = true // disable that feature
  var stepIndex = useStepIndex()
  store.useRerenderIfChange(() => {
    return [
      store.steps[stepIndex]?.abiLoadingStatus,
      store.steps[stepIndex].function_name,
      store.steps[stepIndex].function_signature,
      store.steps[stepIndex].from,
      store.steps[stepIndex].to,
      store.steps[stepIndex].manualAddress,
      store.steps[stepIndex].deployedAddress,
      store.steps[stepIndex].deployedAlias,
      store.steps[stepIndex].using_review_files,
      store.steps[stepIndex].manualData,
      store.steps[stepIndex].data,
      store.steps[stepIndex].parameters,
      store.steps[stepIndex].abi,
    ]
  })

  var previousSteps = store.steps.filter((s, index) => index < stepIndex)
  if (!store.steps[stepIndex]) store.steps[stepIndex] = {}
  var step = store.steps[stepIndex]

  // Update nonce when address change.

  useEffect(() => {
    var controller = new AbortController()
    var abortSignal = controller.signal
    updateNonce(abortSignal)
    return () => {
      controller.abort()
    }
  }, [step.from])

  // get abi for encode step (not compile
  useEffect(() => {
    if (step.type == COMPILE_SMART_CONTRACT) return
    const contracts = store.steps
      .slice(0, stepIndex)
      ?.filter((s) => s.type == COMPILE_SMART_CONTRACT)
    var cancel
    ;(async () => {
      if (store.steps[stepIndex].manualABI) {
        return
      }

      store.steps[stepIndex].abi = null
      store.steps[stepIndex].abiLoadingStatus = "loading"
      store.updateStore()

      // var connecctedAbiFromDeployments = contracts.find(
      //   (x) =>
      //     x.deployedAddress?.toLowerCase() ==
      //     store.steps[stepIndex].to?.toLowerCase(),
      // )?.abi

    // How to get the correct smart contract?
    //  if store.steps[stepIndex].to is like this 0x0000000000000000000000000000000000000001 [1]
    // then the connected ABI should be from step number [1] (steps[0]) in the FULL step list,
    // not the 1st compile step in the filtered list (those are different when there are
    // non-compile steps interleaved with compile steps).
    // if 0x0000000000000000000000000000000000000003 then step number [3] (steps[2]).
    //
    // Additionally, when a previous compile step uses a manual/real address (e.g. a
    // mainnet USDC address), the destination address won't be the synthetic 0x...000N
    // placeholder. Match it directly against deployedAddress / manualAddress of any
    // previous compile step so its ABI is still picked up.

      var connecctedAbiFromDeployments = null
      var toAddress = store.steps[stepIndex].to
      if (toAddress) {
        // Treat an ABI as usable only if it actually describes a contract
        // (has at least one function or a constructor). Otherwise we should
        // fall through to the Etherscan lookup so a manual address pointing
        // to a real on-chain contract (e.g. USDC) still gets its real ABI.
        var isUsableAbi = (abi) =>
          Array.isArray(abi) &&
          abi.some(
            (entry) =>
              entry &&
              (entry.type == "function" || entry.type == "constructor"),
          )

        // 1. Synthetic placeholder address: 0x000...000<stepNumber>
        var toAddressAsNumber = parseInt(toAddress)
        if (
          Number.isFinite(toAddressAsNumber) &&
          toAddressAsNumber >= 1 &&
          toAddressAsNumber == Math.floor(toAddressAsNumber) &&
          toAddressAsNumber <= stepIndex // must reference a previous step
        ) {
          var referencedStep = store.steps[toAddressAsNumber - 1]
          if (
            referencedStep &&
            referencedStep.type == COMPILE_SMART_CONTRACT &&
            isUsableAbi(referencedStep.abi)
          ) {
            connecctedAbiFromDeployments = referencedStep.abi
          }
        }

        // 2. Real / manual address: match against any previous compile step
        if (!connecctedAbiFromDeployments) {
          var lowerTo = toAddress.toLowerCase()
          var matchingContract = contracts.find(
            (c) =>
              (c.deployedAddress &&
                c.deployedAddress.toLowerCase() == lowerTo) ||
              (c.manualAddress &&
                typeof c.manualAddress == "string" &&
                c.manualAddress.toLowerCase() == lowerTo),
          )
          if (matchingContract && isUsableAbi(matchingContract.abi)) {
            connecctedAbiFromDeployments = matchingContract.abi
          }
        }
      }

             

      if (connecctedAbiFromDeployments) {
        store.steps[stepIndex].abi = connecctedAbiFromDeployments
        store.steps[stepIndex].abiLoadingStatus = "ready"
        store.updateStore()
      } else {
        var to = store.steps[stepIndex].to
        const result = await requestJSON(
          "POST",
          "/get_solidity_by_address",
          {
            ethAddress: to,
            network: store.network,
          },
          true,
        )
        if (cancel) return
        store.steps[stepIndex].abi = result?.abi
        store.steps[stepIndex].abiLoadingStatus = "ready"
        store.updateStore()
        updateData()
      }
    })()
    return () => {
      cancel = true
    }
  }, [
    store.steps[stepIndex].to,
    store.steps[stepIndex].manualABI,
    // Also re-run when any *previous* compile step's ABI changes (and when
    // the number of compile steps changes). Without this, if step 4 is added
    // before step 3 finishes compiling, step 4's `abi` is set to null and is
    // never recomputed once step 3's `abi` becomes available.
    store.steps
      .slice(0, stepIndex)
      .filter((s) => s.type == COMPILE_SMART_CONTRACT)
      .map((s) => (s.abi ? s.abi.length : 0))
      .join(","),
    store.steps
      .slice(0, stepIndex)
      .map((s) => (s.deployedAddress || "") + "|" + (s.manualAddress || ""))
      .join(","),
  ])

  // Update data when parameters change.
  useEffect(updateData, [
    JSON.stringify(step.parameters),
    step.function_signature,
  ])

  // Update data when bytecode change (smart contract)
  useEffect(updateData, [step.bytecode])

  useEffect(() => {
    store.updateAbi(stepIndex)
  }, [qs().review_id && store.steps[stepIndex].using_review_files])

  function clickOpenFilesDialog() {
    step.dialogOpen = true
    store.updateStore()
  }

  var thisFunctionABI = getThisFunctionABI()
  function getThisFunctionABI() {
    var tmp
    if (step.type == COMPILE_SMART_CONTRACT) {
      tmp = store.steps[stepIndex].abi?.find((x) => x.type == "constructor")
      if (!tmp) tmp = { inputs: [] }
    } else {
      if (!step.function_signature) return
      tmp = store.steps[stepIndex].abi?.find(
        (x) => x.signature == step.function_signature,
      )
    }
    return tmp
  }

  // Fix default parameters when abi changed. ignore while loading
  // How it is working?
  // Check the signature of the function from the compiled contract
  // And check the signature of this function in this step. If they are different
  // It's mean the function signature changed from the moment the user defined the function
  // In that case we need to delete the parameters
  // We do not compare the "signature" field since we don't always have it.
  // Instead we delete the "signature" field and compare the inputs, and outputs.
  // We do not compare only the inputs, because we need the outputs to show the relevant "expected output" fields
  function fixParametersWhenConstructrABIChange() {
    if (step.manualData) return
    thisFunctionABI = getThisFunctionABI()

    // Remove the signature from thisFunctionABI (The ABI from the compiled smart contract)

    if (!thisFunctionABI) return
    if (step.abiLoadingStatus == "loading") return
    if (!step.parameters) {
      // console.log('#set parameters to []4')
      step.parameters = []
    }

    if (step.parameters.length > thisFunctionABI.inputs.length) {
      // console.log('#set parameters to []9')
      step.parameters = step.parameters.slice(0, thisFunctionABI.inputs.length)
      store.updateStore()
    }
    return

    // try decode if cannot decode

    // Remove the signature from "step.parameters"
    var stepParametersSetForToCompare = step.parameterSetFor
    try {
      stepParametersSetForToCompare = JSON.stringify({
        ...JSON.parse(store.steps[1].parameterSetFor),
        signature: undefined,
      })
    } catch (err) {}

    if (stepParametersSetForToCompare != JSON.stringify(toCompare)) {
      step.parameters = defaultParametersFor(thisFunctionABI)
      step.parameterSetFor = JSON.stringify(toCompare)
      store.updateStore()
    }
  }
  useEffect(fixParametersWhenConstructrABIChange, [
    thisFunctionABI,
    step.abiLoadingStatus,
  ])

  useEffect(() => {
    if (store.steps[stepIndex].description && !showDescrtionInput) {
      setShowDescrtionInput(true)
    }
  }, [store.steps[stepIndex].description])

  function changeInput(index, e) {
    // console.log('changeInput',index,e)
    // console.log('#set parameters to []1')
    store.steps[stepIndex].parameters = store.steps[stepIndex].parameters || []
    var v = e.target ? e.target.value : e
    store.steps[stepIndex].parameters[index] = v
    // console.log('pr',store.steps[stepIndex].parameters)
    store.removeResults(stepIndex)
    store.updateStore()
  }

  function updateData(exitOnFail = false) {
    if (step.manualData) return
    var data = ""
    var currentDeps = [JSON.stringify(step.parameters), step.function_signature]
    if (step.currentDeps == currentDeps) {
      console.error("already calculated")
      return
    }
    step.currentDeps = currentDeps
    if (!step.abi) {
      step.data = "0x"
      store.updateStore()
      return //no step.abi yet
    }

    try {
      if (step.type == COMPILE_SMART_CONTRACT) {
        var contract = new web3.eth.Contract(step.abi)
        data = contract
          .deploy({
            data: step.bytecode,
            arguments: step.parameters,
          })
          .encodeABI()
      } else {
        var contract = new web3.eth.Contract(step.abi)
        // console.error(contract)
        var m = contract.methods[step.function_name](...step.parameters)
        data = m.encodeABI()
      }
    } catch (err) {
      console.log("CANNOT ENCODE CANNOT ENCODE", { exitOnFail })
      console.log("STEP ABI", step.abi)
      if (exitOnFail) return
      // return
      var thisABI
      if (step == "COMPILE_SMART_CONTRACT") {
        thisABI = step.abi.find((x) => x.type == "constructor")
      } else {
        thisABI = step.abi.find((x) => x.signature == step.function_signature)
      }
      if (thisABI) {
        // console.log('#set parameters to []8')
         
        updateData(true)
        console.error(err.message)
      }
    } finally {
      step.data = data
      store.updateStore()
    }
  }

  async function updateNonce(abortSignal) {
    if (step.manualAddress) return
    if (step.type != COMPILE_SMART_CONTRACT) return

    if (!store.steps[stepIndex].deployedAddress) {
      store.steps[stepIndex].deployedAddress =
        await getNewContractAddress(store.steps[stepIndex].from)
      store.updateStore()
    }
  }
  
  //@ts-ignore
  useEffect( () => {
    (async ()=>{
      store.steps[stepIndex].deployedAddress =
      await getNewContractAddress(store.steps[stepIndex].from)
      store.updateStore()
    })()
  },[store.steps[stepIndex].from])

  function changeFunctionSignature(newName, newSignature) {
    fixParametersWhenConstructrABIChange()
    updateData()
    store.updateStepFunctionsInUse(newName, store.currentStoryId, false)
    store.updateStore()
  }
  function updateFunctionFromData() {
    if (step.data.length == 0) {
      delete step.function_name
      delete step.function_signature
      // console.log('#set parameters to []2')
      step.parameters = []
    } else {
      var signature = step.data.slice(0, 4 * 2 + 2)
      var data = step.data.slice(4 * 2 + 2)
      if (step.abi) {
        var funcAbi = step.abi.find((x) => x.signature == signature)
        // console.error({signature,funcAbi})
        if (!funcAbi) return
        step.function_name = funcAbi.name
        step.function_signature = signature
        var params = web3.eth.abi.decodeParameters(funcAbi.inputs, data)
        // console.log('#set parameters to []3')
        step.parameters = []
        for (var i = 0; i < params.__length__; i++) {
          step.parameters.push(params[i])
        }
      }
      // console.error(step.parameters)
      // console.error(step.data)
    }
    store.updateStore()
  }

  const getArgumentValue = (inputType, index) => {
    if (store.steps[stepIndex].parameters) {
      if (inputType.match(/bool/)) {
        return typeof store.steps[stepIndex].parameters[index] == "boolean"
          ? store.steps[stepIndex].parameters[index]
          : ""
      } else {
        return store.steps[stepIndex].parameters[index] || ""
      }
    } else {
      return ""
    }
  }

  const onRequestClose = async () => {
    await store.invalidateReviewAbiCache(qs().review_id)
    store.updateAbi(stepIndex)
    setShowEditReviewFileModal(false)
  }

  var isOneSide = store.getView() == "oneside"
  var isStepReadOnly = store.isStepReadOnly(stepIndex)

  return (
    <>
      {showEditReviewFileModal && (
        <CompileDialogForReview
          reviewId={qs().review_id}
          requestClose={() => {
            onRequestClose()
          }}
        />
      )}
      <StyleWrapper>
        <StepHeader skipStepNumber={skipStepNumber} />
        <div
          css={`
            background: white;
            padding-left: 10px;
            padding-right: 10px;
            padding-top: ${isOneSide ? "0px" : "20px"};
          `}
        >
          {store.isDryRun &&
            isLoggedIn &&
            store.userIsAllowed(isLoggedIn?.email) &&
            (showDescrtionInput ? (
              <div
                css="
            margin-top: 20px"
              >
                <ValueOrChoose
                  label="Description"
                  autofocus
                  onBlur={() => {
                    if (!store.steps[stepIndex].description) {
                      setShowDescrtionInput(false)
                    }
                  }}
                  disabled={isStepReadOnly}
                  hint=""
                  hideType
                  type="multilinetext"
                  value={store.steps[stepIndex].description}
                  onChange={(v) => {
                    console.log({ v })
                    store.steps[stepIndex].description = v
                    store.updateStore()
                  }}
                />{" "}
              </div>
            ) : (
              <>
                {!isStepReadOnly ? (
                  <div
                    css="
            color:#799fd4;
            cursor: pointer;
            text-decoration-line: underline;"
                    onClick={() => {
                      setShowDescrtionInput(true)
                    }}
                  >
                    Add description
                  </div>
                ) : null}
              </>
            ))}

          {step.type == COMPILE_SMART_CONTRACT && (
            <div>
              {qs().review_id && (
                <div
                  css="
                margin-top: 10px"
                >
                  <div
                    css="display: flex;
                  align-items: baseline;
                  justify-content: flex-start;"
                  >
                    <div
                      css={`
                        width: 110px;
                        flex-shrink: 0;
                      `}
                    >
                      Files
                    </div>
                    <div
                      css={`
                        font-weight: bolder;
                      `}
                    >
                      {store.steps[stepIndex].using_review_files ? (
                        <span>Using the review files</span>
                      ) : (
                        <span>Not relying on the review files</span>
                      )}
                    </div>
                    {!isStepReadOnly && (
                      <div
                        css="
                        margin-left: 5px;
                        color:rgb(121 159 212);
                        cursor: pointer;
                        text-decoration-line: underline;"
                        onClick={() => {
                          store.steps[stepIndex].using_review_files =
                            !store.steps[stepIndex].using_review_files
                          store.updateStore()
                          store.updateByte32List()
                        }}
                      >
                        Change
                      </div>
                    )}
                  </div>
                  {store.steps[stepIndex].using_review_files &&
                  !store.steps[stepIndex].abi.length &&
                  !store.steps[stepIndex].bytecode ? (
                    <div css="padding-left: 110px; padding-top: 10px;">
                      <span css="color: red;">No review files available.</span>
                      <span
                        css="
                        margin-left: 5px;
                        color:rgb(121 159 212);
                        cursor: pointer;
                        text-decoration-line: underline;"
                        onClick={() => {
                          setShowEditReviewFileModal(true)
                        }}
                      >
                        Add review files
                      </span>
                    </div>
                  ) : null}
                </div>
              )}

              {!isStepReadOnly &&
                store.steps[stepIndex].using_review_files &&
                qs().review_id && (
                  <div
                    css="display: flex;
                  align-items: baseline;
                  margin-top:10px;
                  justify-content: flex-start;"
                  >
                    <div
                      css={`
                        width: 110px;
                        flex-shrink: 0;
                      `}
                    >
                      Review files
                    </div>

                    <div
                      onClick={() => {
                        if (!isStepReadOnly) {
                          store.showEditReviewFileModal(qs().review_id)
                        }
                      }}
                      css={`
                        color: #799fd4;
                        cursor: ${isStepReadOnly ? "invalid" : "pointer"};
                        font-weight: bolder;
                      `}
                      // @ts-ignore
                    >
                      Edit review files
                      {step.compiling && (
                        <span
                          css={`
                            width: 100%;
                          `}
                        >
                          <Progress time={5000} />
                        </span>
                      )}
                      &nbsp;
                      {step.compilationErrors && (
                        <span
                          css={`
                            color: red;
                          `}
                        >
                          Compilation errors
                        </span>
                      )}
                    </div>
                  </div>
                )}

              {!isStepReadOnly &&
                (!store.steps[stepIndex].using_review_files ||
                  !qs().review_id) && (
                  <div
                    css="display: flex;
                  align-items: baseline;
                  margin-top:10px;
                  justify-content: flex-start;"
                  >
                    <div
                      css={`
                        width: 110px;
                        flex-shrink: 0;
                      `}
                    >
                      Solidity files
                    </div>

                    <div
                      onClick={() => {
                        if (!isStepReadOnly) {
                          clickOpenFilesDialog()
                        }
                      }}
                      css={`
                        color: #799fd4;
                        cursor: ${isStepReadOnly ? "invalid" : "pointer"};
                        font-weight: bolder;
                      `}
                      // @ts-ignore
                    >
                      Edit solidity files
                      {step.compiling && (
                        <span
                          css={`
                            width: 100%;
                          `}
                        >
                          <Progress time={5000} />
                        </span>
                      )}
                      &nbsp;
                      {step.compilationErrors && (
                        <span
                          css={`
                            color: red;
                          `}
                        >
                          Compilation errors
                        </span>
                      )}
                    </div>
                  </div>
                )}
            </div>
          )}

          {store.isDryRun && (
            <div
              css="
            margin-top: 5px"
            >
              <ValueOrChoose
                label="Sender"
                disabled={
                  isStepReadOnly ||
                  (thisFunctionABI?.stateMutability == "view" &&
                    thisFunctionABI?.constant != true)
                }
                hint=""
                hideType
                type="address"
                value={store.steps[stepIndex].from}
                onChange={(v) => {
                  store.steps[stepIndex].from = v
                  store.removeResults(stepIndex)
                  store.updateStore()
                }}
              />
            </div>
          )}

          {/* {step.type == COMPILE_SMART_CONTRACT && !step.manualAddress && (
            <div
              css={`
                display: flex;
                margin-top: 5px;
              `}
            >
              <div
                css={`
                  width: 110px;
                  flex-shrink: 0;
                `}
              >
                New Address
              </div>
              <div>
                <ParameterDisplay
                  type="address"
                  values={store.steps[stepIndex].deployedAddress}
                />
                &nbsp;
                {!isStepReadOnly && (
                  <span
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    onClick={() => {
                      store.removeResults()
                      step.manualAddress = true
                      store.updateStore()
                    }}
                  >
                    Change
                  </span>
                )}
              </div>
            </div>
          )} */}

          {false && step.type == COMPILE_SMART_CONTRACT && step.manualAddress && (
            <div
              css={`
                margin-top: ${isOneSide ? "10px" : "20px"};
              `}
            >
              {/* <ParameterInput
                //@ts-ignore
                width="100%"
                wrapperWidth="100%"
                label="New Address"
                optional
                type="address"
                value={step.deployedAddress}
                onChange={(e) => {
                  if (e) {
                    store.removeResults()
                    step.deployedAddress = e.target.value
                    store.updateStore()
                  }
                }}
              /> */}
              <br />
              <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => {
                  store.removeResults()
                  step.manualAddress = false
                  updateNonce()
                  store.updateStore()
                }}
              >
                Back
              </span>
            </div>
          )}

          {step.type != COMPILE_SMART_CONTRACT &&
            showDestinationAddressInput && (
              <div
                css={`
                  margin-top: ${isOneSide ? "unset" : "10px"};
                `}
              >
                <ParameterInput
                  //@ts-ignore
                  width="100%"
                  wrapperWidth="100%"
                  grow={1}
                  disabled={isStepReadOnly}
                  label="Destination"
                  hideType
                  optional
                  type="address"
                  value={store.steps[stepIndex].to}
                  onChange={(e) => {
                    if (e) {
                      store.removeResults(stepIndex)
                      store.steps[stepIndex].to = e.target?.value
                      store.updateStore()
                    }
                  }}
                />
              </div>
            )}

          {step.type != COMPILE_SMART_CONTRACT &&
            !step.manualData &&
            store.steps[stepIndex]?.abi?.filter(
              (abiField) => abiField.type == "function",
            )?.length > 0 && (
              <div
                css={`
                  /* margin-top: 10px; */
                `}
              >
                <FunctionChooser
                  disabled={isStepReadOnly}
                  changeHook={changeFunctionSignature}
                />
              </div>
            )}

          {!step.manualData &&
            (!step.errors || step.errors.length == 0) &&
            ((thisFunctionABI?.inputs?.length > 0 &&
              step.abiLoadingStatus == "ready") ||
              step.abiLoadingStatus == "loading") && (
              <div
                css={`
                  margin-top: ${isOneSide ? "unset" : "10px"};
                `}
              >
                {true && (
                  <Input
                    width="100%"
                    wrapperWidth="100%"
                    labelBackground="white"
                    hideBottomBorder
                    label={
                      step.type == COMPILE_SMART_CONTRACT
                        ? "Arguments"
                        : "Parameters"
                    }
                  >
                    <div>
                      {step.abiLoadingStatus == "loading" && (
                        <div
                          css={`
                            margin: 15px;
                          `}
                        >
                          <CircularProgress size={12} />
                        </div>
                      )}
                      {step.abiLoadingStatus == "ready" &&
                        thisFunctionABI?.inputs?.map((input, index) => (
                          <div
                            key={index}
                            css={`
                              /* margin: 15px; */
                            `}
                          >
                            <ValueOrChoose
                              //@ts-ignore
                              width="100%"
                              disabled={isStepReadOnly}
                              wrapperWidth="100%"
                              chooseValue=""
                              label={
                                input.name
                                  ? input.name
                                  : "Parameter #" + (index + 1)
                              }
                              value={getArgumentValue(input.type, index)}
                              onChange={changeInput?.bind(null, index)}
                              type={input.type}
                              components={input.components}
                              onChoose={() => {}}
                              list={
                                input.type == "address"
                                  ? //@ts-ignore
                                    previousSteps
                                      .filter((s) => s.deployAlias)
                                      .map((x) => x.deployAlias)
                                  : []
                              }
                            />
                          </div>
                        ))}
                    </div>
                  </Input>
                )}
              </div>
            )}

          <div
            css={`
              margin-top: ${isOneSide ? "10px" : "20px"};
            `}
          >
            <ParameterInput
              //@ts-ignore
              width="100%"
              disabled={isStepReadOnly}
              wrapperWidth="100%"
              labelBackground="white"
              label="Ether"
              optional
              hideType
              type="ether"
              value={store.steps[stepIndex].value || "0"}
              onChange={(e) => {
                store.removeResults(stepIndex)
                store.steps[stepIndex].value = e.target.value
                store.updateStore()
              }}
            />
          </div>

          {/* {!step.manualABI && !store.isReadOnly && step.type!=COMPILE_SMART_CONTRACT && <div>
        <b>Custom ABI:</b>&nbsp;
        None
        {<span style={{textDecoration:'underline',cursor:'pointer'}} onClick={()=>{
          step.manualABI=true
          store.updateStore()          
        }}>Change (advanced)</span>}
      {step.manualABI && <div>
      <textarea onChange={e=>{
        step.abi=e.target.value
      }} 
      css={`
        width:100%;
        height:10px;
      `}
      value={step.abi || ''}
      />
      <br/>

        </div>} */}
          <div
            css="
          margin-top: 20px"
          >
            <BlockEdit />
          </div>

          {step.type != COMPILE_SMART_CONTRACT && !step.manualData && (
            <div css="margin-top: 20px;display:flex;">
              <div
                css={`
                  width: 110px;
                  flex-shrink: 0;
                  font-size: 12px;
                `}
              >
                TX Data
              </div>
              <div
                css={`
                  font-weight: bolder;
                `}
              >
                <ParameterDisplay
                  css="font-weight:bolder;"
                  type="address"
                  values={store.steps[stepIndex].data}
                />
                &nbsp;
                {!isStepReadOnly &&
                  SHOW_CHANGE_DATA &&
                  step.type != COMPILE_SMART_CONTRACT && (
                    <span
                      style={{
                        color: "#799fd4",
                        textDecoration: "underline",
                        fontWeight: 100,
                        cursor: "pointer",
                        fontSize: 13,
                      }}
                      onClick={() => {
                        step.manualData = true
                        store.removeResults()
                        store.updateStore()
                      }}
                    >
                      Change
                    </span>
                  )}
              </div>
            </div>
          )}

          {step.manualData && (
            <div css="margin-top: 20px;">
              <ParameterInput
                //@ts-ignore
                width="100%"
                grow={1}
                wrapperWidth="100%"
                label="Data"
                labelBackground="white"
                optional
                hideType
                type="bytes"
                value={step.data}
                onChange={(e) => {
                  store.removeResults()
                  step.data = e.target.value
                  updateFunctionFromData()
                }}
              />
              <br />
              <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => {
                  step.manualData = false
                  updateData()
                  store.updateStore()
                }}
              >
                &lt; Back to function chooser
              </span>
            </div>
          )}

          {step.type != COMPILE_SMART_CONTRACT && <ManualABI />}

          {false && step.type == COMPILE_SMART_CONTRACT && (
            <div css="margin-top: 20px;">
              <b>Nonce:</b>&nbsp;
              <ParameterDisplay
                type="uint"
                values={store.steps[stepIndex].nonce * 1 + 1}
              />
            </div>
          )}

          {step.type == COMPILE_SMART_CONTRACT && <CompileDialog />}
        </div>
      </StyleWrapper>
    </>
  )

  function ManualABI() {
    store.useRerenderIfChange(() => [
      store.isReadOnly,
      store.steps[stepIndex]["defaultStep"],
      store.steps[stepIndex].manualABI,
      store.steps[stepIndex].abi?.length,
      store.steps[stepIndex].abiString,
    ])
    return (
      <div>
        <div
          css={`
            display: flex;
            font-size: 12px;
            margin-top: 10px;
          `}
        >
          <div
            css={`
              width: 110px;
              flex-shrink: 0;
            `}
          >
            ABI
          </div>
          <div
            css={`
              flex-grow: 1;
              font-weight: 700;
            `}
          >
            {!step.manualABI && "Automatic"}
            {step.manualABI && "Manual"}
            &nbsp;
            {!isStepReadOnly && (
              <span
                css={`
                  color: #799fd4;
                  cursor: pointer;
                  text-decoration-line: underline;
                  font-size: 13px;
                  font-weight: 100;
                `}
                onClick={() => {
                  store.steps[stepIndex]["manualABI"] =
                    !store.steps[stepIndex]["manualABI"]
                  if (store.steps[stepIndex]["abi"]) {
                    store.steps[stepIndex]["abiString"] = JSON.stringify(
                      store.steps[stepIndex]["abi"] || [],
                    )
                  } else if (store.steps[stepIndex]["abiString"]) {
                    store.steps[stepIndex]["abiString"] =
                      store.steps[stepIndex]["abiString"]
                  } else {
                    store.steps[stepIndex]["abiString"] = []
                  }
                  onUpdateABIStringUpdateABIArray()
                }}
              >
                Change
              </span>
            )}
          </div>
        </div>
        {step.manualABI && (
          // <div css={`display:flex;`}>
          // <div css={`width:110px;flex-shrink:0;`}>ABI JSON</div>
          // <div css={`flex-grow:1;`}>
          <div css={`max-height:100px;overflow:auto;`}>
            <ParameterInput
              type="json"
              disabled={isStepReadOnly}
              label="ABI"
              labelBackground="white"
              grow={1}
              wrapperWidth="100%"
              onChange={(e) => {
                store.steps[stepIndex]["abiString"] = e.target.value
                onUpdateABIStringUpdateABIArray()
              }}
              value={
                store.steps[stepIndex]["abiString"] ||
                JSON.stringify(store.steps[stepIndex]["abi"]) ||
                "[]"
              }
            />
            {/* </div> */}
            {/* </div> */}
          </div>
        )}
      </div>
    )
  }

  function onUpdateABIStringUpdateABIArray() {
    try {
      var parsed = JSON.parse(store.steps[stepIndex]["abiString"])
      if (Array.isArray(parsed)) {
        parsed=addSignaturesToABI(parsed)
        store.steps[stepIndex]["abi"] = parsed

      } else {
        store.steps[stepIndex]["abi"] = []
      }
    } catch (err) {
      store.steps[stepIndex]["abi"] = []
    }
    store.updateStore()
  }
}
